var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useRef, useState } from "react";
import useUserConfiguration from "../utils/updateUserConfiguration";
import logo from "../assets/logo.png";
import { Viewer3D } from "helloar-3d-sdk";
import { fetchProduct } from "../utils/apiManager";
import { useAppDispatch, useAppSelector } from "../hooks/hooks";
import "./Preview.css";
const getReplacePart = (partId, nodes) => {
    return {
        parameters: {
            part: partId,
            nodes: nodes,
            position: {
                position: {
                    x: 0,
                    y: 0,
                    z: 0,
                },
                scale: {
                    x: "1",
                    y: "1",
                    z: "1",
                },
                rotation: {
                    x: "0",
                    y: 0,
                    z: 0,
                },
            },
        },
        type: "ReplacePartGlb",
        id: "6cc506e6-0ce8-41dd-8990-c0430fd1f140",
    };
};
const getUnbindPart = (instance) => {
    return {
        parameters: {
            instance: instance,
        },
        type: "Unbind",
        id: "ca7d3ec2-486f-4c51-9a9e-1b27d238343e",
    };
};
const getBindPart = (partId, position, rotation, instance) => {
    return {
        parameters: {
            part: partId,
            // nodes: nodes,
            position: {
                position: position || {
                    x: 0,
                    y: 0,
                    z: 0,
                },
                scale: {
                    x: "1",
                    y: "1",
                    z: "1",
                },
                rotation: rotation || {
                    x: 0,
                    y: 0,
                    z: 0,
                },
            },
            instance: instance || "6b49a29e-64f8-4f20-a14e-0a5b4414602c",
        },
        type: "BindPart",
        id: "e7b661df-ca20-4ff9-ab9e-4cee7a8ae88b",
    };
};
const createMaterialRuleJSON = (textureUrl, nodeName) => {
    return {
        id: "5f979442-e8a8-492b-8b02-75e74c82cbac",
        type: "Manual",
        actions: [
            {
                parameters: {
                    material: {
                        name: nodeName,
                        texture: textureUrl,
                        center: {
                            x: 0.5,
                            y: 0.5,
                        },
                    },
                },
                type: "ChangeMaterial",
            },
        ],
    };
};
export default function Preview({ productViewerRef, }) {
    const [productViewer, setProductViewer] = useState();
    const [prevProductId, setPrevProductId] = useState();
    const [product, setProduct] = useState();
    const [isPostRenderingDone, setIsPostRenderingDone] = useState(true);
    const [is3dSceneLoading, setIs3dSceneLoading] = useState(false);
    const [sceneLoadingProgress, setSceneLoadingProgress] = useState(0);
    const dispatch = useAppDispatch();
    const prevRules = useRef({});
    const { getSelectedOption, userConfiguration2, getRules } = useUserConfiguration();
    const configData = useAppSelector((state) => state.configData.current);
    const option = getSelectedOption("System", userConfiguration2.type);
    const productId = option && option[0] && option[0].productId;
    const bindPart = useCallback((pid, position, rotation, instance) => {
        return new Promise((resolve, reject) => {
            var _a;
            const actions = [getBindPart(pid, position, rotation, instance)];
            let ruleJSON = {
                id: "989f39f2-4f73-4259-a670-1f59f6a1821d",
                iconText: "BindPart",
                type: "Manual",
                actions,
            };
            if (productViewerRef) {
                (_a = productViewerRef === null || productViewerRef === void 0 ? void 0 : productViewerRef.current) === null || _a === void 0 ? void 0 : _a.runCustomRule({ rule: ruleJSON, node: [], completionHandler: () => { } }, () => {
                    resolve(true);
                }, () => {
                    reject(false);
                });
            }
        });
    }, [productViewerRef]);
    const unbindPart = useCallback((instance) => {
        return new Promise((resolve, reject) => {
            var _a;
            const actions = [getUnbindPart(instance)];
            let ruleJSON = {
                id: "75fd16c9-70d1-469c-9be9-a94341bd7c8e",
                iconText: "UnbindPart",
                type: "Manual",
                actions,
            };
            if (productViewerRef) {
                (_a = productViewerRef.current) === null || _a === void 0 ? void 0 : _a.runCustomRule({ rule: ruleJSON, node: [], completionHandler: () => { } }, () => {
                    resolve(true);
                }, () => {
                    reject(false);
                });
            }
        });
    }, [productViewerRef]);
    const hideNode = useCallback((nodeName, completionHandler) => {
        var _a;
        const ruleJSON = {
            id: "4175419f-ace6-4ca4-bf2d-bfe9b53f75c1",
            type: "Manual",
            actions: [
                {
                    parameters: {
                        node: nodeName, //add correct node here
                    },
                    type: "HideNode",
                    id: "e526d733-de1c-4b6c-bf6a-b61688d2c807",
                },
            ],
        };
        if (productViewerRef) {
            (_a = productViewerRef === null || productViewerRef === void 0 ? void 0 : productViewerRef.current) === null || _a === void 0 ? void 0 : _a.runCustomRule({
                rule: ruleJSON,
                node: nodeName,
                completionHandler: () => {
                    completionHandler();
                },
            });
        }
    }, [productViewerRef]);
    const showNode = useCallback((nodeName, completionHandler) => {
        var _a;
        let ruleJSON = {
            id: "4175419f-ace6-4ca4-bf2d-bfe9b53f75c1",
            type: "Manual",
            actions: [
                {
                    parameters: {
                        node: nodeName, //add correct node here
                    },
                    type: "ShowNode",
                    id: "e526d733-de1c-4b6c-bf6a-b61688d2c807",
                },
            ],
        };
        if (productViewerRef) {
            (_a = productViewerRef === null || productViewerRef === void 0 ? void 0 : productViewerRef.current) === null || _a === void 0 ? void 0 : _a.runCustomRule({
                rule: ruleJSON,
                node: nodeName,
                completionHandler: () => {
                    completionHandler();
                },
            }, () => { });
        }
    }, [productViewerRef]);
    const replacePart = useCallback((nodes, pid, completionHandlerok) => {
        var _a;
        // return new Promise((resolve, reject) => {
        const actions = [getReplacePart(pid, nodes)];
        let ruleJSON = {
            id: "21cbc580-8270-4d23-bc61-f0d27a711af3",
            iconText: "init",
            type: "Manual",
            actions,
        };
        if (productViewerRef) {
            (_a = productViewerRef === null || productViewerRef === void 0 ? void 0 : productViewerRef.current) === null || _a === void 0 ? void 0 : _a.runCustomRule({
                rule: ruleJSON,
                node: null,
                completionHandler: () => {
                    completionHandlerok();
                },
            });
        }
        // });
    }, [productViewerRef]);
    ;
    // ,
    // [productViewerRef]
    // );
    const applyMaterial = useCallback((nodeName, textureUrl, completionHandler) => {
        var _a;
        const ruleJSON = createMaterialRuleJSON(textureUrl, nodeName);
        if (productViewerRef) {
            (_a = productViewerRef === null || productViewerRef === void 0 ? void 0 : productViewerRef.current) === null || _a === void 0 ? void 0 : _a.runCustomRule({
                rule: ruleJSON,
                node: nodeName,
                completionHandler: () => {
                    completionHandler();
                },
            });
        }
    }, [productViewerRef]);
    const runRules = useCallback((rules) => __awaiter(this, void 0, void 0, function* () {
        if (!(rules === null || rules === void 0 ? void 0 : rules.length))
            return; // Return early if no rules
        // Move "replacePart" rules to the beginning
        const reorderedArray = rules.sort((a, b) => a.type === "replacePart" && b.type !== "replacePart" ? -1 : 1);
        // Utility function to extract nodes from a rule
        const getNodes = (rule) => {
            var _a;
            if (rule.node) {
                return Array.isArray(rule.node) ? rule.node : [rule.node];
            }
            if ((_a = rule.parameters) === null || _a === void 0 ? void 0 : _a.node) {
                return Array.isArray(rule.parameters.node)
                    ? rule.parameters.node
                    : [rule.parameters.node];
            }
            return [];
        };
        // Function to execute a single rule
        const executeRule = (index) => __awaiter(this, void 0, void 0, function* () {
            if (index >= reorderedArray.length) {
                return; // All rules executed
            }
            const rule = reorderedArray[index];
            const nodes = getNodes(rule);
            return new Promise((resolve) => {
                const completionHandler = () => {
                    resolve(); // Proceed to the next rule
                };
                try {
                    switch (rule.type) {
                        case "replacePart":
                            if (rule.pid !== undefined) {
                                replacePart(nodes, rule.pid, completionHandler);
                            }
                            else {
                                console.error("Missing `pid` for replacePart rule.");
                                completionHandler();
                            }
                            break;
                        case "hide":
                            nodes.forEach((node) => hideNode(node, completionHandler));
                            break;
                        case "show":
                            nodes.forEach((node) => showNode(node, completionHandler));
                            break;
                        case "applyMaterial":
                            if (rule.textureUrl) {
                                nodes.forEach((node) => applyMaterial(node, rule.textureUrl, completionHandler));
                            }
                            else {
                                console.error("Missing `textureUrl` for applyMaterial rule.");
                                completionHandler();
                            }
                            break;
                        default:
                            console.error("Unknown rule type:", rule.type);
                            completionHandler(); // Skip unrecognized rules
                    }
                }
                catch (error) {
                    console.error("Error executing rule:", error);
                    completionHandler(); // Proceed even if there’s an error
                }
            }).then(() => executeRule(index + 1)); // Execute the next rule after the current one
        });
        // Start executing from the first rule
        yield executeRule(0);
    }), [applyMaterial, hideNode, replacePart, showNode] // Ensure all dependencies are stable
    );
    const postRenderRules = (rules) => __awaiter(this, void 0, void 0, function* () {
        var _a;
        for (const key in rules) {
            if (productViewerRef) {
                (_a = productViewerRef === null || productViewerRef === void 0 ? void 0 : productViewerRef.current) === null || _a === void 0 ? void 0 : _a.runCustomRule({ rule: rules[key], node: [], completionHandler: () => { } }, () => { });
            }
        }
        setSceneLoadingProgress(100);
        setIsPostRenderingDone(true);
    });
    useEffect(() => {
        setPrevProductId(productId);
        dispatch({
            type: "SET_PRODUCT_ID",
            payload: {
                value: productId,
            },
        });
    }, [productId, productViewerRef]);
    const hasObjectValueChanged = useCallback((value, prevValue) => {
        if (JSON.stringify(value) === JSON.stringify(prevValue)) {
            return false;
        }
        return true;
    }, []);
    useEffect(() => {
        (() => __awaiter(this, void 0, void 0, function* () {
            const rules = getRules();
            let changedNodes = [];
            try {
                for (const item of configData) {
                    if (item.name in rules) {
                        let ruleKey = item.name;
                        if (rules[ruleKey] && rules[ruleKey].length > 0) {
                            yield runRules(rules[ruleKey]);
                        }
                    }
                }
            }
            catch (error) {
                console.error(error);
            }
            prevRules.current = rules;
        }))();
        //run when userConfiguration2 changes
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userConfiguration2]);
    useEffect(() => {
        (() => __awaiter(this, void 0, void 0, function* () {
            const rules = getRules();
            for (const item of configData) {
                if (item.name in rules) {
                    let ruleKey = item.name;
                    if (rules[ruleKey].length > 0) {
                        try {
                            yield runRules(rules[ruleKey]);
                        }
                        catch (error) {
                            console.error(error);
                        }
                    }
                }
            }
            prevRules.current = rules;
        }))();
        //run when prevProductId changes
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [prevProductId]);
    const concatRules = () => __awaiter(this, void 0, void 0, function* () {
        const rules = getRules();
        for (const item of configData) {
            if (item.name in rules) {
                let ruleKey = item.name;
                if (rules[ruleKey] && rules[ruleKey].length > 0) {
                    try {
                        yield runRules(rules[ruleKey]);
                    }
                    catch (error) {
                        console.error(error);
                    }
                }
            }
        }
        // return concatenatedRules
    });
    const setup3dViewer = (currentProduct) => __awaiter(this, void 0, void 0, function* () {
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        yield runRules(option[0].rules);
        setIsPostRenderingDone(false);
        dispatch({
            type: "SET_PRODUCT",
            payload: {
                value: currentProduct,
            },
        });
        if (productViewerRef === null || productViewerRef === void 0 ? void 0 : productViewerRef.current) {
            (_c = (_b = productViewerRef === null || productViewerRef === void 0 ? void 0 : productViewerRef.current) === null || _b === void 0 ? void 0 : _b.getViewer()) === null || _c === void 0 ? void 0 : _c.destroy();
            setSceneLoadingProgress(0);
            setIsPostRenderingDone(false);
            setIs3dSceneLoading(true);
            (_e = (_d = productViewerRef === null || productViewerRef === void 0 ? void 0 : productViewerRef.current) === null || _d === void 0 ? void 0 : _d.getViewer()) === null || _e === void 0 ? void 0 : _e.reinitialiseWeb3d(document.getElementById("3d-viewer"));
            (_g = (_f = productViewerRef === null || productViewerRef === void 0 ? void 0 : productViewerRef.current) === null || _f === void 0 ? void 0 : _f.getViewer()) === null || _g === void 0 ? void 0 : _g.init({
                modelDetails: {
                    glb: currentProduct.three_dee_model.glb,
                },
                rules: [],
                settings: {
                    lights: (_j = (_h = currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.rendering_rules) === null || _h === void 0 ? void 0 : _h.lightsV2) !== null && _j !== void 0 ? _j : [],
                    envMapMeta: (_l = (_k = currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.rendering_rules) === null || _k === void 0 ? void 0 : _k.envMapV2) !== null && _l !== void 0 ? _l : (_m = currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.rendering_rules) === null || _m === void 0 ? void 0 : _m.envMapMeta,
                    shadow: {
                        enabled: true,
                        intensity: (_o = currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.rendering_rules) === null || _o === void 0 ? void 0 : _o.shadowIntensity,
                    },
                },
                disableModelEntryAnimation: false,
                onProgress: (progress) => {
                    setSceneLoadingProgress(progress);
                    // onProgress && onProgress(progress);
                },
                onError: (errorMessage) => {
                    console.log("onload 3d model failed: ", errorMessage);
                },
                onModelRendered: () => __awaiter(this, void 0, void 0, function* () {
                    // setIs3dSceneLoading(false);
                    if (Object.keys(currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.rules).length > 0) {
                        const parsedRules = JSON.parse(currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.rules.json).rules;
                        const PostRenderRules = parsedRules.filter((rule) => rule.type === "PostRender");
                        yield postRenderRules(PostRenderRules);
                    }
                    concatRules();
                }),
            });
        }
    });
    useEffect(() => {
        setIsPostRenderingDone(false);
        setIs3dSceneLoading(true);
        fetchProduct(productId)
            .then((res) => {
            setProduct(res);
            setup3dViewer(res);
        })
            .catch((err) => {
            console.error(err);
        });
    }, [productId]);
    return (_jsxs("div", Object.assign({ style: { width: "100%", height: "100%" }, className: "flex-grow items-center w-full p-4 mx-auto h-full relative flex align-center justify-center" }, { children: [is3dSceneLoading && !isPostRenderingDone && (_jsx("div", Object.assign({ className: "loaderContainer" }, { children: _jsx("div", Object.assign({ className: "loaderContainingWrapper" }, { children: _jsx("div", Object.assign({ className: "loaderWrapper" }, { children: _jsxs("div", Object.assign({ className: "loaderOutline" }, { children: [_jsx("div", { className: "loaderProgress", style: { width: `${sceneLoadingProgress}%` } }), _jsxs("span", Object.assign({ className: "loaderText" }, { children: [sceneLoadingProgress, "%"] }))] })) })) })) }))), _jsx("div", Object.assign({ id: "3d-viewer", style: {
                    display: !isPostRenderingDone ? "none" : "flex",
                }, className: " h-full w-full rounded text-gray-600 flex items-center justify-center" }, { children: product && (_jsx(Viewer3D, { data: product, ref: productViewerRef, onSceneLoaded: () => {
                        setup3dViewer(product);
                    }, server: process.env.NODE_ENV === "production" ? "PROD" : "DEV", disableSpin: true, disableSpec: true })) })), _jsx("img", { src: logo, alt: "logo", className: "mr-auto  w-62 h-auto ml-4 absolute bottom-40 right-4" })] })));
}
